'use client';

import PerfBarChart, { type PerfBar } from './PerfBarChart';

const data: PerfBar[] = [
  { label: 'A1-Standard', value: 19, valueLabel: '19x', color: 'gray' },
  { label: 'A2-Full', value: 44, valueLabel: '44x', color: 'yellow' },
  { label: 'A2-Lite', value: 305, valueLabel: '305x', color: 'yellow' },
];

export default function A2RtfA1vsA2() {
  return (
    <PerfBarChart
      headerTitle="A1 vs A2 Inference Speed"
      headerDescription="How the new A2 models compare to the original A1 architecture on the same hardware."
      title="Real-time factor on Apple M5, A1 vs A2"
      subtitle="64-sample buffer at 48 kHz, Apple M5. Real-time factor is how many times faster than real time the model runs; higher is better."
      data={data}
      yAxisTitle="Real-time factor (higher = faster)"
    />
  );
}
